// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#credit-convert-confirmation___BV_modal_backdrop_{opacity:.5!important}", ""]);
// Exports
module.exports = exports;
